export default "__VITE_ASSET__BKwQX7E1__"